import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgNewsletterSettingsOutline } from './svg/newsletter-settings_outline.svg.js';

/**
 * @deprecated - use NewsletterSettings.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const NewsletterSettingsOutline = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgNewsletterSettingsOutline, { viewBox: "0 0 24 24", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "NewsletterSettingsOutline" }));
};

export { NewsletterSettingsOutline as default };
//# sourceMappingURL=NewsletterSettingsOutline.js.map
